import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { isEqual, uniqWith, replace } from 'lodash';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ConsultationPM, StructureRassRecherche } from '../../models/structure-dto.model';
import { ConsultationPMRequestDto } from '../../models/consultation-pm-request-dto.model';
import { CriteresConsultationPersonne } from '../../models/criteres-consultation-personne.model';
import { CriteresRecherchePersonne } from '../../models/criteres-recherche-personne.model';
import { CriteresRechercheStructure } from '../../models/criteres-recherche-structure.model';
import { environment } from '../../../environments/environment';
import { PersonnePhysique } from '../../models/personne-physique.model';

@Injectable({
  providedIn: 'root',
})
export class RassService {

  constructor(
    private readonly http: HttpClient,
  ) {}

  /**
   * Get person list by criteria
   * @param criteres criteres de recherche de personne physique dans le RASS
   */
  public getPersonnesByCriteres(criteres: CriteresRecherchePersonne): Observable<PersonnePhysique[]> {
    const params = new HttpParams({ fromObject: criteres as any });
    // workaround but could be removed with Angular 14: form.reset() + new FormControl('', { nonNullable: true })
    const paramsStr = replace(params.toString(), /null/g, '');
    const paramsRes = new HttpParams({ fromString: paramsStr as any });

    return this.http.get<PersonnePhysique[]>(`${environment.API_URL}personnePP/rechercher`, { params: paramsRes });
  }

  /**
 * Consultation de la personne dans le RASS
 * @param criteres de consultation de personne physique dans le RASS
 */
  public consultationPP(criteres: CriteresConsultationPersonne): Observable<PersonnePhysique> {
    const params = new HttpParams()
      .set('idNatPS', criteres.idNatPs)
      .set('isTest', criteres.isTest);
    return this.http.get<PersonnePhysique>(`${environment.API_URL}personnePP/consulter`, { params: params });
  }

  /**
   * Méthode pour le service Rass structure/recherche quand il soit accessible, if faut décommenter cette méthodo et commenter la méthode du mock
   * @param criteres Parameters used to filter the results to search
   */
  public getStructures(criteres: CriteresRechercheStructure): Observable<StructureRassRecherche[]> {
    const params = new HttpParams({ fromObject: criteres as any });
    return this.http
      .get<StructureRassRecherche>(`${environment.API_URL}structure/recherche`, { params })
      .pipe(
        map(x => uniqWith(x, isEqual))
      );
  }

  /**
   * Méthode pour le service Rass structure/consultationPM quand il soit accessible, if faut décommenter cette méthodo et commenter la méthode du mock
   * @param typeStructure string
   * @param idStructure string
   * @param codePostal string
   * @param raisonSociale string
   */
  public consultationPM(
    typeStructure: string,
    idStructure: string,
    codePostal?: string,
    raisonSociale?: string
  ): Observable<ConsultationPM[]> {
    const params = new HttpParams()
      .set('typeStructure', typeStructure)
      .set('idStructure', idStructure)
      .set('codePostal', codePostal)
      .set('raisonSociale', raisonSociale)
      .set('isTest', 'false');

    return this.http.get<ConsultationPM[]>(`${environment.API_URL}structure/consultationPM`, { params });
  }

  /**
   * Permet de récupérer plusieurs structures depuis le RASS via l'API consultationPM
   * @param consultationPMRequestList la liste des critères de recherche
   */
  public consultationPMs(consultationPMRequestDtoList: ConsultationPMRequestDto[]): Observable<ConsultationPM[]> {
    return this.http.post<ConsultationPM[]>(`${environment.API_URL}structure/consultationPMs?isTest=false`,
      consultationPMRequestDtoList
    );
  }

}
